import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { eventService } from '../services/apiClient';
import { AuthContext } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import { formatDate, formatCountdown } from '../utils/dateFormatters';

const EventRegistrationPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [event, setEvent] = useState(null);
  const [registered, setRegistered] = useState(false);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    fetchEvent();
  }, [id]);

  const fetchEvent = async () => {
    try {
      const response = await eventService.getEventById(id);
      setEvent(response.data.event);
      setRegistered(response.data.event.registeredUsers.some(u => u._id === user?.id));
    } catch (error) {
      console.error('Failed to fetch event:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    try {
      await eventService.registerForEvent(id);
      setRegistered(true);
      alert('Successfully registered for the event!');
    } catch (error) {
      alert('Failed to register: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (!event) return <div className="text-center py-8">Event not found</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="bg-purple-500 h-64 flex items-center justify-center text-white text-4xl font-bold">
            {event.name}
          </div>

          <div className="p-8">
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div>
                <p className="text-sm text-gray-600 mb-1">Date</p>
                <p className="text-xl font-bold text-gray-800">{formatDate(event.date)}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Time</p>
                <p className="text-xl font-bold text-gray-800">
                  {event.startTime} - {event.endTime || 'TBA'}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Venue</p>
                <p className="text-xl font-bold text-gray-800">{event.venue}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Registrations</p>
                <p className="text-xl font-bold text-gray-800">
                  {event.registrationCount}
                  {event.maxCapacity && `/${event.maxCapacity}`}
                </p>
              </div>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">About the Event</h2>
              <p className="text-gray-600 leading-relaxed">{event.description}</p>
            </div>

            <div className="mb-8">
              <p className="text-lg text-blue-600 font-semibold mb-4">{formatCountdown(event.date)}</p>
            </div>

            {registered ? (
              <div className="bg-green-100 border border-green-400 text-green-700 px-6 py-4 rounded">
                ✓ You are registered for this event!
              </div>
            ) : (
              <button
                onClick={handleRegister}
                className="w-full bg-purple-600 text-white py-4 rounded-lg font-bold hover:bg-purple-700 transition-colors text-lg"
              >
                Register for Event
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventRegistrationPage;
